import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { GeneralService } from '../services/general.service';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import { AvtAlertComponent } from '../avt-alert/avt-alert.component';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';

@Component({
  selector: 'app-avt-liste-alert',
  templateUrl: './avt-liste-alert.component.html',
  styleUrls: ['./avt-liste-alert.component.scss']
})
export class AvtListeAlertComponent implements OnInit {
  datasourceAlerte=[];
  datasourceInterlocuteur=[];
  datasourceAlerteIsLoadet : boolean = false;
  listBtnAlerte:Array<any> =[]
  list_Btn_Alerte:Array<any> = [{name:"ajouterAlert",class:"colorBlue",text:"Ajouter",disabled : false,icon:"add"},
                              {name:"modifierAlert",class:"colorGreen",text:"Modifier",icon:"edite"},
                              {name:"supprimerAlert",class:"colorRed",text:"Supprimer",disabled : false,icon:"delete"}]
  columnsAlerte = {TableRD:[]};
  columnsAlerteIsLoadet : boolean = false;
  showTabAlert : boolean = false;
  @Input() code : string = "";
  @Input() type : string = "";
  @Input() disabled : boolean = false;
  showTabInterlocuteur : boolean = false;
  //@ViewChild//
  @ViewChild("listeAlectComponen",{static:false}) listeAlectComponen : AvtListesComponent;
  exist : boolean = true;
  constructor(public dialog: MatDialog,public generalService :GeneralService) { }

  ngOnInit()
  {
    if(!this.disabled)
      this.listBtnAlerte = this.list_Btn_Alerte;
    else
      this.listBtnAlerte = []
    this.getAlert();
    this.initListBtnAlerte();
  }
  initListBtnAlerte()
  {
    this.listBtnAlerte.forEach(btn =>
    {
      btn.disabled = this.disabled;
    });
  }
  getAlert()
  {
      this.getDataAlert();
      this.getColumnsAlerte()
  }
  getDataAlert()
  {
    if(this.generalService.isNotEmpty(this.generalService.userPerso))
    {
      var url = this.generalService.url;
      if(this.generalService.isNotEmpty(this.type))
      {
        if(this.type == "collaborateur")
          url += "AvtAlerteColl&param="+this.generalService.userPerso.UserName;
        if(this.type == "client")
          url += "avtalerte&param="+this.code;
      }
      else
        url += "avtAlerte2&param=" + this.generalService.userPerso.UserName;;
      this.generalService.rechercheTable(url).subscribe(data =>
      {
        data.forEach(d =>
        {
          // d.avtAlerte_Statut =
        });
        this.datasourceAlerte = data;
        this.datasourceAlerteIsLoadet = true;
        if(this.columnsAlerteIsLoadet)
        {
          this.showTabAlert = true;
          setTimeout( () =>
          {
            this.listeAlectComponen.setDataSource(data)
          },10);
        }
      })
    }
    else
      setTimeout(()=>
      {
        this.getDataAlert();
      },100)
  }
  getColumnsAlerte()
  {
    this.generalService.rechercheTable( "recherche/TbRecherche?param=avtAlerte2").subscribe(data =>
    {
      this.columnsAlerte = data;
      this.columnsAlerte.TableRD.forEach(col =>
      {
          col.TableRD_ReadOnly = true;
      })
      if(this.type == "collaborateur")
        this.columnsAlerte.TableRD = this.columnsAlerte.TableRD.filter(col => {return col.TableRD_Champs != "Nom"})
      this.columnsAlerteIsLoadet = true;

      if(this.datasourceAlerteIsLoadet)
      {
        this.showTabAlert = true;
        setTimeout( () =>
        {
          this.listeAlectComponen.setDataSource(this.datasourceAlerte)
        },10);
      }
    });
  }
  showAlert(avtAlerte_Id)
  {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.data={avtAlerte_Id:avtAlerte_Id,code:this.code,datasourceInterlocuteur:this.datasourceInterlocuteur,type:this.type}
    var dialogRef = this.dialog.open(AvtAlertComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result =>
    {
      if(result.status)
      {
        this.getDataAlert();
        this.generalService.dialogSuccess("Alerte enregistrer",true);
      }
      else
      {
        this.generalService.dialogSuccess("Alerte non enregistrer",false)
      }
    });
  }
  clickBtnHeat(event)
  {
    switch (event.name)
    {
      case "ajouterAlert":
      {
        this.showAlert("-1")
        break;
      }
      case "modifierAlert":
      {
        this.showAlert(event.row.avtAlerte_Id)
        break;
      }
      case "supprimerAlert":
      {
        this.supprimerAlert(event.row)
        break;
      }
    }
  }
  supprimerAlert(row)
  {
    const dialogConfig = this.generalService.dialogConfig;
      dialogConfig.autoFocus = true;
      var dialogRef = this.generalService.dialog.open(AvtDialogDeleteComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result =>
      {
        if(result == "supprimer")
        {
          var deleteFn = this.generalService.supprimerSanMsgConfirm(row.avtAlerte_Id,"avtalerte");
          if(deleteFn != null)
          {
            this.exist = false;
            this.listBtnAlerte[2].disabled = true
            deleteFn.subscribe(data =>
            {
              this.getDataAlert();
              this.generalService.dialogSuccess("Elément supprimer",true);
              this.exist = true;
              this.listBtnAlerte[2].disabled = false;
            },
            error =>
            {
                this.generalService.dialogSuccess("Elément non supprimé",false);
                this.exist = true;
                this.listBtnAlerte[2].disabled = false;
            });
          }
        }
        if(result == "annuler")
        {
        }
      });

  }
}
